import { MonoTypeOperatorFunction, Observable, fromEvent, timer } from 'rxjs';
import { concatMap, distinctUntilChanged, filter, repeat, retryWhen, shareReplay, takeUntil } from 'rxjs/operators';

export function remainSubscribedOnError<T>(): MonoTypeOperatorFunction<T> {
  return retryWhen((errors: Observable<any>) => errors);
}

export function shareReplay1<T>(): MonoTypeOperatorFunction<T> {
  return shareReplay<T>({ refCount: true, bufferSize: 1 });
}

export function distinctUntilChangedId<T extends { id: number }>(): MonoTypeOperatorFunction<T> {
  return distinctUntilChanged<T>((previous: T, current: T) => previous?.id === current?.id);
}

export function poll(interval: number, start = 0) {
  return function <T>(source: Observable<T>): Observable<T> {
    return timer(start, interval).pipe(concatMap(() => source));
  };
}

export function whenPageVisible() {
  const visibilitychange$ = fromEvent(document, 'visibilitychange').pipe(shareReplay1());

  const pageVisible$ = visibilitychange$.pipe(filter(() => document.visibilityState === 'visible'));

  const pageHidden$ = visibilitychange$.pipe(filter(() => document.visibilityState === 'hidden'));

  return function <T>(source: Observable<T>): Observable<T> {
    return source.pipe(takeUntil(pageHidden$), repeat({ delay: () => pageVisible$ }));
  };
}
